const STORAGE_KEY = 'controlPanelOpen';
const DEFAULT_VALUE = window.innerWidth >= 960;
export function isControlPanelOpen(context) {
    const storage = context.getMethodsOf('storage');
    const open = storage.getItem(STORAGE_KEY);
    return typeof open === 'boolean' ? open : DEFAULT_VALUE;
}
export function openControlPanel(context, open) {
    const storage = context.getMethodsOf('storage');
    storage.setItem(STORAGE_KEY, open);
}
